import {
  LOADING,
  SEARCH,
  THREAD_ID,
  REPLIES,
  NEW_POST,
  ON_CHANGE,
} from './types'

const initialState = {
  list: [],
  index: 0,
  newPost: false,
  searchValue: '',
  commentsLoaded: false,
}

const commentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case THREAD_ID:
      return {
        ...state,
        threadId: action.threadId,
      }
    case SEARCH:
      return {
        ...state,
        searchValue: action.value,
      }
    case REPLIES:
      return {
        ...state,
        list: action.list,
      }
    case NEW_POST:
      return {
        ...state,
        newPost: !state.newPost,
      }
    case ON_CHANGE:
      return {
        ...state,
        [action.property]: action.value,
      }
    case LOADING:
      return {
        ...state,
        [action.loadingType]: action.isLoading,
      }
    default:
      return state
  }
}

export default commentsReducer
